const PHASE_DISPLAY_NAMES: Record<string, string> = {
  vorab: "Vorbereitung",
  durchfuehrung: "Baustellendoku",
  inbetriebnahme: "Inbetriebnahme",
  vot: "VOT",
  projektdokumentation: "Projektdokumentation",
};

export function resolvePhaseFolderName(phaseId?: string, phaseTitle?: string): string {
  if (phaseTitle && phaseTitle.trim()) {
    return phaseTitle.trim();
  }

  if (!phaseId) {
    return "Unbekannte Phase";
  }

  const phasePart = phaseId.split("-").slice(1).join("-") || phaseId;
  return PHASE_DISPLAY_NAMES[phasePart] ?? phasePart;
}

